<template>
  <div>
    <!-- Start Breadcrump Area  -->
    <SliderBannerNotinTwo :obj="NOTARIA.Theme.Blog" type="blog" />
    <!-- End Breadcrump Area  -->

    <!-- Start blog Area  -->
    <div class="rn-blog-area rn-section-gap bg_color--1">
      <v-container>
        <!-- <v-row>
          <v-col cols="12">
            <div class="section-title section-title--2 text-center">
              <h2 class="heading-title">Latest News</h2>
              <p>
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration.
              </p>
            </div>
          </v-col>
        </v-row> -->
        <!-- End .row -->
        <BlogNotinList :Home="false" type="blog"/>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from '../store/index'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const PageName="Blog"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
</script>
